module.exports = __webpack_public_path__ + "img/share-09.19b39e3b.jpg";